import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=28a0af71&scoped=true&lang=pug"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.styl?vue&type=style&index=0&id=28a0af71&prod&lang=stylus&scoped=true&external"
import style1 from "./Aside.vue?vue&type=style&index=1&id=28a0af71&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0af71",
  null
  
)

export default component.exports